import React, { useEffect, useState } from 'react';
import './Index.css';
import { Box, Paper, Stack, Typography } from '@mui/material';
import HttpService from '../../services/HttpService';
import Constants from '../../utils/constants';
import { useStore } from '../../utils/store';
import AlertMessageComponent from '../../components/AlertMessageComponent';

import CalendarView from './parts/CalendarView';
import { useCrewCalender } from './StoreCrewCalendar';
const CrewDashboard: React.FC = () => {
  const { setCrews } = useCrewCalender();
  const [crewList, setCrewList] = useState<any[]>([]);

  useEffect(() => {
    fetchCrews();
  }, []);
  const { getAdmin } = useStore();
  const [httpError, setHttpError] = useState({
    message: '',
    open: false,
  });

  const fetchCrews = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.crewsURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          isActive: 1,
          limit: -1,
        }
      );
      console.log(response);
      if (response.data) {
        setCrewList(response.data.paginateRecords);
        setCrews(response.data.paginateRecords);
      } else {
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({
        message: error.message,
        open: true,
      });
    }
  };

  function handleCloseAlert() {
    setHttpError((prev) => {
      return {
        ...prev,
        open: false,
      };
    });
  }
  return (
    <Stack>
      <Box id="main" className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <div className="mt-2">
              <Typography variant="h6">Crews Schedule</Typography>
              <CalendarView
                crewList={crewList}
                token={getAdmin()}
              ></CalendarView>
            </div>
          </div>
        </section>
        <AlertMessageComponent
          type={'error'}
          open={httpError.open}
          handleClose={handleCloseAlert}
          message={httpError.message}
        />
        {''}
      </Box>
    </Stack>
  );
};

export default CrewDashboard;
